export function searchRefresh() {
  const path = window.location.pathname
  if (path.includes('returning')) {
    const regEx = /(returning)\/(\w|-|.)+/
    path.replace(regEx, '')
    window.location.href = path
  }
  window.location.reload()
}
